const identificationRepository = (fetch: CustomFetch) => ({
  async getCoverageInfo(srId: string) {
    const { covered: isCovered } = await fetch<{ covered: boolean }>(`/v1/direct/user/identification/payment/${srId}`)

    return { isCovered }
  },
  async getIdentMethod(srId: string, sid: string) {
    return await fetch<IdentMethod>(`/v3/signature-requests/${srId}/signatures/${sid}/ident-method`)
  },
})

export default identificationRepository
